<template>
  <div>
    <list
      ref="refLanguageList"
      sort-by="IdiomaId"
      :refetch-records="fetchLanguages"
      refetch-records-name="idiomas"
      :actions="actions"
      key-field="idiomaId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteLanguage"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refLanguageList = ref(null)
    /* Services */
    const {
      fetchLanguages,
      deleteLanguage,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.language.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.language.columns.abbreviation'),
        key: 'abreviatura',
      },
      {
        label: i18n.t('humanResources.language.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Idioma',
        routeName: 'apps-human-resources-language-edit',
        params: ['idiomaId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Idioma',
        params: ['idiomaId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-language-add',
        label: i18n.t('Routes.LanguageAdd'),
        aclAction: 'create',
        aclResource: 'Idioma',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refLanguageList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchLanguages,
      deleteLanguage,
    }
  },
}
</script>
